// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"kpa-z"};